/** The logo will fallback to mobile if desktop is not provided. */
export type ElectionLogo = {
    /** An image uri. */
    mobile: string
    /** An image uri. */
    desktop?: string
}

export type StateElection = {
    type: 'state'
    state: 'act' | 'nsw' | 'nt' | 'qld' | 'sa' | 'tas' | 'vic' | 'wa'
    year: number
    logo: ElectionLogo
}

export type FederalElection = {
    type: 'federal'
    year: number
    logo: ElectionLogo
}

export type Election = StateElection | FederalElection

/**
 * Returns the election id, provided an election object.
 * Used in the url as a slug.
 */
export const getElectionId = (election: Election) => {
    if (election.type === 'federal') {
        return `federal-election-${election.year}`
    } else {
        return `${election.state}-election-${election.year}`
    }
}
